<template>
  <select 
    class="bg-white border-0 rounded-lg py-2 px-4 w-100 text-black"
    @change="$emit('selected', $event.target.value)"
  >
    <slot></slot>
  </select>
</template>

<style scoped>
select:focus {
  outline: none
}
</style>